import { render, staticRenderFns } from "./index.vue?vue&type=template&id=558cd860&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StickySideButton: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/StickySideButton.vue').default,LayoutsHeader: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/layouts/Header.vue').default,Card: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/Card.vue').default,Advertisements: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/Advertisements.vue').default,SupportBanner: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/SupportBanner.vue').default,RadioCarouselItem: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/CarouselItem.vue').default,RadioCarousel: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/Carousel.vue').default})
